import React, { PropTypes } from 'react';
import { MainResources, SecondaryResources } from '../../components';

const ResourcesContainer = ({ mainAssetsDownloadLink, secondaryAssetsDownloadLink }) => (
  <div className="container">
    <div className="row">
      <div className="col-sm-12">
        <header className="section-header">
          <h2>
            <img src="https://cdn.auth0.com/website/assets/pages/press/img/icon-image-60cc4b34ca.svg" alt="Announcements icon" />
          </h2>
          <h1>Media Resources</h1>
        </header>
      </div>
    </div>
    <div className="row resources-grid">
      <MainResources assetsDownloadLink={mainAssetsDownloadLink} />
      <SecondaryResources assetsDownloadLink={secondaryAssetsDownloadLink} />
    </div>
  </div>
);

ResourcesContainer.propTypes = {
  mainAssetsDownloadLink: PropTypes.string.isRequired,
  secondaryAssetsDownloadLink: PropTypes.string.isRequired
};

export default ResourcesContainer;



// WEBPACK FOOTER //
// ./src/pages/press/components/ResourcesContainer/ResourcesContainer.js